<template>
    <!-- Main Wrapper -->
    <div class="main-wrapper">
        <layouts></layouts>
        <sidebar-menu></sidebar-menu>
        <div class="page-wrapper">
            <div class="content">
                <pageaddheader :title="title" :title1="title1" :items="items" />
                <!-- /product list -->
                <div class="card">
                    <div class="card-body pt-1">
                        <div class="table-top d-flex justify-content-start gap-2">
                           
                            <div class="search-set " style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="search-input">
                                    <a class="btn btn-searchset"><img src="@/assets/img/icons/search-white.svg"
                                            alt="img" /></a>
                                    <div id="DataTables_Table_0_filter" class="dataTables_filter">
                                        <label>
                                            <input type="search" class="form-control form-control-sm"
                                                placeholder="Search..." aria-controls="DataTables_Table_0"
                                                v-model="query" />
                                        </label>
                                    </div>
                                </div> 
                            </div>

                            <div class="form-group" style="margin-top: 10px !important; margin-bottom: 0px !important;">
                                <div class="input-groupicon" style="z-index: 100;">
                                    <DatePicker 
                                        v-model:value="periode" 
                                        type="date"
                                        range
                                        format="YYYY-MM-DD"
                                        value-type="format"
                                        :clearable="true"
                                        class="picker"
                                        style="width: 300px !important;" 
                                    />
                                </div>
                            </div>
                            
                            <div class="wordset">
                                <ul>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="Generate"
                                            @click="generateData"
                                            class="d-flex flex-column justify-content-center  align-items-center mt-2 btn btn-primary p-1">
                                            <i class='bx bx-refresh' style="font-size: 25px;"></i> 
                                        </a>
                                    </li>
                                    <li>
                                        <router-link class=" d-flex flex-column justify-content-between  align-items-center btn btn-primary p-1 mt-2" to="importschedule" style=" margin-bottom: 0px !important; ">
                                            <img src="../../../assets/img/import-from-excel.png" alt="img" width="25" />
                                        </router-link>
                                    </li>
                                    <li>
                                        <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel"
                                            @click="export_schedule"
                                            class="d-flex flex-column justify-content-between align-items-center btn btn-primary p-1 mt-2" style="  margin-bottom: 0px !important; ">
                                            <img src="../../../assets/img/Import_fill.png" alt="img" width="25" />

                                            <!-- <img
                                                src="../../../assets/img/icons/excel.svg" alt="img" width="25" /> <span
                                                class="text-black">
                                                Excel
                                            </span> -->
                                        </a>

                                    </li>

                                
                                </ul>
                            </div>

                        </div>
                        
                        <div class="table-responsive mt-0">
                            <a-table
                                :columns="columns"
                                :data-source="filteredData"
                                :scroll="{ x: 'max-content' }"
                                bordered
                                row-key="employee_id"
                                @change="handleTableChange" :pagination="pagination" :loading="loading"
                            >
                                <template #bodyCell="{ column, record }">
                                <!-- Default Cell -->
                                <template v-if="column.key === 'employee_name'">
                                    <b>{{ record.employee_name }}</b><br>{{ record.employee_id2 }}
                                </template>

                                <!-- Dynamic Tanggal Cells -->
                                <template v-else>
                                    <div @click="editSchedule(record, column.key)" v-if="record[column.key]" class="green-cell" style="cursor: pointer;">
                                    {{ getJam(record[column.key]) }}<br />
                                    <small>{{ getShift(record[column.key]) }}</small>
                                    </div>
                                    <div v-else>-</div>
                                </template>
                                
                                </template>
                            </a-table>
                        </div>

                    </div>
                </div>
                <!-- /product list -->
            </div>
        </div>
    </div>

</template>
<script>

import Cookies from "js-cookie";
import axios from "axios";
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import { watch } from "vue";
import { base_url, AlertPopup2, AlertBottom, appendForm, timeout, selectedBranch, goPage } from "@/assets/js/function";

export default {
    name: "schedulelist",
    components: {
        DatePicker    
    },
    data() {
        return {
            title: "Schedule List",
            title1: "manage schedule",
            items: [
                {
                    text: "Add Schedule ",
                    addname: "/addschedule",
                },
            ],
            periode: [],
            data: [],
            columns: [],
            query: "",
            dataSource: [],

            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: false
            },

            loading: false,
        };
    },
    created() {
        const token = Cookies.get("token_refresh");
        this.config = {
            headers: { Authorization: `Bearer ` + token },
            timeout: 30000,
        }
        
        const branch = parseInt(localStorage.getItem("selectedBranch")) || 0;

        //Update local and shared state
        this.filter = branch;
        selectedBranch.value = branch;

        localStorage.setItem('actionState', 'view')


        const now = new Date();
        const start = new Date(now);
        const end = new Date(now);
        end.setDate(start.getDate() + 5);

        this.periode = [
            this.formatDateLocal(start),
            this.formatDateLocal(end),
        ];

        this.index();
    },

    mounted() {

        watch(selectedBranch, () => {
            this.index()
        }, { immediate: true })

        const savedPage = localStorage.getItem("lastPage");
        if (savedPage) {
            this.pagination.current = parseInt(savedPage);
        }
    },

    computed: {
        filteredData() {
            if (this.query == '') {
                return this.dataSource;
            }
            const lowerCaseQuery = this.query.toLowerCase();

            return this.dataSource.filter(item =>
                item.employee_name.toLowerCase().includes(lowerCaseQuery)
            );
        }
    },
    methods: {
        formatDateLocal(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-based
            const day = String(date.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        },

        handleTableChange(pagination) {
            this.pagination = pagination; // keep pagination reactive
            localStorage.setItem("lastPage", pagination.current);
        },

        async export_schedule() {
            let formData = new FormData();
            appendForm(formData);
            
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom", startDate);
                formData.append("dto", endDate);
            }

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading()
            // return true

            const api = base_url + '/v3/schedule/export';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;

            if(data.status){
                const fileUrl = data.data.file_report;

                if (!this.periode) {
                    console.error("Error: this.periode is undefined or null");
                    return;
                }

                if (!fileUrl) {                            
                    AlertPopup("error", "", "Download link not found", 1500, false);
                    return;
                }

                const link = document.createElement("a");
                link.href = fileUrl;
                link.setAttribute("download", "Schedule.xlsx"); // You can change the filename
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

            }else {
                AlertPopup2("error", "", data.message || "Unknown error", true, 1500);
            }

            

        },

        async index() {
            this.loading = true;

            const formData = new FormData();
            appendForm(formData);

            // Tanggal periode
            if (this.periode && this.periode.length === 2) {
                const [startDate, endDate] = this.periode;
                formData.append("dfrom", startDate);
                formData.append("dto", endDate);
            }

            for (let [key, value] of formData.entries()) {
                console.log(key, value);
            }
            // CloseLoading()
            // return true


            const api = base_url + '/v3/schedule/index';
            const res = await axios.post(api, formData, { timeout });
            const data = res.data;
            console.log('cek index skejul', data)
            
            if(data.status){
                const tanggalMap = data.data.mapping_date || {}
                const rows = data.data.schedule || []
                this.dataSource = rows
                this.columns = [
                    { title: 'Employee Name', dataIndex: 'employee_name', key: 'employee_name', fixed: 'left' }
                ]
                // Kolom dinamis berdasarkan tanggal_map
                Object.entries(tanggalMap).forEach(([index, tanggal]) => {
                    this.columns.push({
                        title: this.formatToMonthDay(tanggal),
                        dataIndex: index,
                        key: index,
                        align: 'center'
                    })
                })

                this.loading = false;
                
                localStorage.setItem('employeeList', JSON.stringify(data.data.data_employee));
                localStorage.setItem('shiftList', JSON.stringify(data.data.data_shift));
                return;
            }else {
                AlertPopup2("error", "", data.message, true, 1500);
            }

                // .finally(() => {
                //     CloseLoading()
                //     return;
                // });
        },
        
        generateData() {
            this.index();
        },
        getJam(value) {
            const parts = value.split('#')
            return parts[2] || ''
        },
        getShift(value) {
            const parts = value.split('#')
            return parts[3] || ''
        },
        formatToMonthDay(dateStr) {
            const date = new Date(dateStr)
            const options = { weekday: 'short', day: '2-digit', month: 'short' }
            return new Intl.DateTimeFormat('en-US', options).format(date)
        },
        editSchedule(record, columnKey) {
            const rawValue = record[columnKey] || '';
            const [id] = rawValue.split('#');

            const formData = new FormData();
            formData.append('id', id);

            axios.post(base_url + 'v3/schedule/detail', formData, this.config)
            .then((response) => {
                console.log(response.data.data[0]);
                if (response.data.status === true) {
                    const detail = response.data.data[0];
                    localStorage.setItem("currentData", JSON.stringify(detail));
                    window.open("/editschedule", "_blank");
                } else {
                    alert("Invalid schedule ID");
                    return;
                }
            })
            .catch((err) => {
                console.error("❌ Error saat ambil detail:", err);
            })
            .finally(()=> {
                // CloseLoading();
                return;
            });
        },
        addNumberToObjects(objArray) {
            for (let i = 0; i < objArray.length; i++) {
                const newObj = { No: i + 1, ...objArray[i] };
                objArray[i] = newObj;
            }
            return objArray;
        },
    },
};
</script>
<style>
.ant-tooltip {
    display: none !important;
}
.green-cell {
  background-color: #28a745 !important;
  color: white !important;
  text-align: center;
  border-radius: 5px;
  padding: 5px;
}
</style>